import type { ComponentType } from "react";
import { Env } from "consts/general";
import { globalErrorHandler, resetStore } from "./middleware";
import withMiddleware from "./reducers";
import { configureStore, Provider, type ConfigureStoreOptions } from "./lib";

export const makeStore = (
  options?: ConfigureStoreOptions["preloadedState"] | undefined
) =>
  configureStore({
    reducer: withMiddleware(resetStore),
    middleware: getDefaultMiddleware => (
      getDefaultMiddleware()
        .concat(globalErrorHandler)
    ),
    devTools: Env.not(Env.Prod),
    ...options,
  });

const appStore = makeStore();

export const withStore = (Component: ComponentType, store = appStore) =>
  () => (
    <Provider
      store={store}
    >
      <Component />
    </Provider>
  );

export { appStore as default };
